import { CSSProperties } from 'react';
import { StudyApproveRejectButtonView } from '../study-approve-reject-button.component';
import { useAdminStudyPermissions, useAdminStudyStatusChange } from '@vivli/features/studies/infrastructure/hook';
import { useStudyContext } from '@vivli/features/studies/infrastructure/context';
import { AdminHeaderButtonView } from '@vivli/shared/views';
import { StudyStatusEnum } from '@vivli/features/studies/infrastructure/enum';
import { DTICommonConst } from '@vivli/shared/infrastructure/constants';
import { useFormState } from 'react-hook-form';

const containerStyle: CSSProperties = {
    display: 'flex'
};

interface StudyWorkflowButtonsComponentProps {
    onSaveClick?: () => void;
    onStatusChange?: (statusDetails) => void;
}

export const StudyWorkflowButtonsComponent = ({ onSaveClick, onStatusChange }: StudyWorkflowButtonsComponentProps) => {
    const { isDirty, isValid } = useFormState();
    const { study, studyIpdPackageSubmitted, handleApproveCurationSubmit, isSavingStudy } = useStudyContext();
    const { userCanApprove } = useAdminStudyPermissions(study, studyIpdPackageSubmitted);
    const studyStatusChange = useAdminStudyStatusChange(study);
    const statusObject = studyStatusChange.getCurationStatusObject();

    const handleOnApprove = () => {
        if (study.status === StudyStatusEnum.CurationQaReviewInProgress) {
            handleApproveCurationSubmit();
        } else {
            return onStatusChange(statusObject?.approveProps);
        }
    };

    return (
        <div style={containerStyle}>
            {userCanApprove() && (
                <StudyApproveRejectButtonView
                    onRejectStudyClick={() => onStatusChange(statusObject?.rejectProps)}
                    onApproveStudyClick={handleOnApprove}
                    onSoftRejectStudyClick={() => onStatusChange(statusObject?.softRejectProps)}
                    approveLabel={statusObject?.approveProps?.buttonText}
                    rejectLabel={statusObject?.rejectProps?.buttonText}
                    softRejectLabel={statusObject?.softRejectProps?.buttonText}
                    showApprove={statusObject?.userCanApprove}
                    showReject={statusObject?.userCanReject}
                    showSoftReject={statusObject?.userCanSoftReject}
                    isLoading={isSavingStudy}
                />
            )}
            {!userCanApprove() && <div>{statusObject?.permFailText}</div>}

            <AdminHeaderButtonView
                title={'Save'}
                onClick={onSaveClick}
                isDisabled={!isDirty || !isValid}
                isLoading={isSavingStudy}
                dataId={DTICommonConst.SaveButton}
            />
        </div>
    );
};
